import React, {memo} from 'react';
import {TableBody, TableRow, TableCell} from '@mui/material';
import DeleteButton from './deleteButton';
import {assets} from '../../../../../../../utils/assetsSrc';
import {hoursToHoursMinutes} from '../../../../utils/helpers';

const TableBodyRows = memo(({rows}) => {

  return (
    <TableBody>
      {rows?.map((row, index) => (
        <TableRow
          key={`${index}`}
          sx={{
            borderBottom: '1px solid #e0e0e0',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
            '&:nth-of-type(even)': {
              backgroundColor: '#fafafa',
            },
            '&:nth-of-type(odd)': {
              backgroundColor: '#ffffff',
            },
          }}>
          {row.map((attendee, attendeeIndex) => (
            <TableCell
              key={attendeeIndex}
              sx={{
                border: '1px solid #e0e0e0',
                textAlign: 'center',
                fontWeight: '500',
                padding: '12px 8px',
                fontSize: '13px',
                minWidth: attendeeIndex === 0 ? '200px' : '120px',
                maxWidth: attendeeIndex === 0 ? '250px' : '150px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                // First column sticky logic with better styling
                ...(attendeeIndex === 0 && {
                  position: 'sticky',
                  left: 0,
                  backgroundColor: 'inherit',
                  zIndex: 2,
                  borderRight: '2px solid var(--primary-blue-color)',
                  boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
                  fontWeight: '600',
                  color: 'var(--primary-blue-color)',
                }),
              }}>
              {attendee}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
});

export default TableBodyRows;
